import React, { useCallback, useState } from 'react';
import { ConnectedDialog } from '../ConnectedDialog';
import { useDispatch } from 'react-redux';
import { closeDialog } from '../../../app/dialog/dialog.actions';
import { useSelectWithParams } from '../../../utils/selector.utils';
import { dialogSelectors } from '../../../app/dialog/dialog.selectors';
import { IBoardExportOptionsDialogProps } from './types';

export const BoardExportOptionsDialog = () => {
  const dispatch = useDispatch();
  const props = useSelectWithParams(
    dialogSelectors.selectDialogProps,
    'boardExportOptionsDialog',
  ) as IBoardExportOptionsDialogProps;

  const [includeCompletedTasks, setIncludeCompletedTasks] = useState(false);

  const onClose = useCallback(() => {
    setIncludeCompletedTasks(false);
    dispatch(closeDialog('boardExportOptionsDialog'));
  }, [dispatch]);

  const handleConfirm = useCallback(() => {
    if (props && props.onConfirm) {
      props.onConfirm({ includeCompletedTasks });
    }
    onClose();
  }, [props, includeCompletedTasks, onClose]);

  return (
    <ConnectedDialog dialogKey="boardExportOptionsDialog">
      <div className="popup delete_popup isVisible">
        <div className="panel">
          <div className="panel-header small-header flex jcsb">
            <h3>Export Options</h3>
            <span className="close-popup close" onClick={onClose}>
              <i className="icon-close"></i>
            </span>
          </div>
          <div className="panel-body">
            <div className="mb-4 mt-1 flex">
              <input
                type="checkbox"
                id="checkbox-include-completed-tasks"
                onChange={(e) => setIncludeCompletedTasks(e.target.checked)}
                checked={includeCompletedTasks}
              />
              <label htmlFor="checkbox-include-completed-tasks">Include completed tasks</label>
            </div>
            <div className="flex aic justify-end">
              <a className="link blueGray mr-2 close" title="" onClick={onClose}>
                Close
              </a>
              <button className="btn green-bg white" onClick={handleConfirm}>
                Export
              </button>
            </div>
          </div>
        </div>
      </div>
    </ConnectedDialog>
  );
};
